import React, { useContext, useState } from "react";
import { get, parseInt, isEmpty } from "lodash";
import {
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
  Form,
  Tabs,
  Tab,
} from "react-bootstrap";
import {
  GetInitials,
  EditActionSlider,
  AddTreeStructure,
  SliderPanel,
  LoaderWrapper,
  ManageDistributionLayoutNew,
  EmployeeDetailsCard,
} from "../../../components";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getCommaSeparatedValuesFromArr,
  getDateWithSlash,
  getFormattedSsn,
  getNullTableItem,
  getPathWithParam,
  MANAGE_CENSUS_ROUTES,
  ROUTES,
  ssnMasking,
  getWithdrawalName,
  MANAGE_TRANSACTION_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_COMPANY_ROUTES,
  manageDistributionFormNames,
  distributionFormFields,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import AddToolTip from "../../../components/AddToolTip";
// import employeeImage from "../../../assets/sample_image.png";

import { EmployeeStatus } from "../../../layouts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  getEmployeeImage,
  getCompanyLogo,
  getWithdrawalRequest,
  getBalances,
  approvalWithdrawalRequest,
  submitWithdrawalRequest,
  getEmployeePlanWithdrawals,
  getEmployeeCensusInformation,
} from "../../../services";
import { Link, useHistory } from "react-router-dom";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { Formik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import WithdrawalRequestEmployeeClassification from "../WithdrawalRequestContainerOld/WithdrawalRequestEmployeeClassification";
import {
  appLayoutStore,
  manageDistributionStore,
  manageTransactionStore,
  setManageDistributionToastInfo,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import {
  faExclamationCircle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faPrint,
} from "@fortawesome/pro-light-svg-icons";
import PayeeDetailsCard from "../../../components/PayeeDetailsCard/PayeeDetailsCard";
import { setManageTransactionToastInfo } from "./../../../contexts/reducers/manage-transaction/actions";
import { CalculateSourceSplit } from "../WithdrawalRequestContainer/CalculateSourceSplitup";
import { globalToastInfo } from "./../../../contexts/reducers/app-layout/actions";
import {
  getValues,
  GetWithdrawalStrategy,
  SourceAllocationCalculationMethod,
} from "../WithdrawalRequestContainer/DistributionConstantsAndFunctions";
import WithdrawalSummaryComponent from "./WithdrawalSummaryComponent";
import WithdrawalRequestPersonalInformationFields from "../WithdrawalRequestContainerOld/WithdrawalRequestPersonalInformation";
import WithdrawalRequestOtherInformation from "../WithdrawalRequestContainerOld/WithdrawalRequestOtherInformation";
import WithdrawalRequestEmploymentAgeDetail from "../WithdrawalRequestContainerOld/WithdrawalRequestEmployeeAgeDetails";
import WithdrawalRequestContactInformationFields from "../WithdrawalRequestContainerOld/WithdrawalRequestContactInformtion";

const initialValues = {};
const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
const fields = distributionFormFields[formName];

const WithdrawalSummaryContainer = (props) => {
  const { state, dispatch } = useContext(manageDistributionStore);
  const { state: state2, dispatch: dispatch2 } = useContext(appLayoutStore);
  const [moreInfoSlideOpen, setMoreInfoSlideOpen] = useState(false);
  const data = get(state, "withdrawalRequestData", []);
  const history = useHistory();
  const { flow, censusId, withdrawalRequestId, fromPage } = useRouterParams();
  const [sliderOpen1, setSliderOpen1] = useState(false);
  const [employeeImage, setEmployeeImage] = useState("");
  const [responseModel, setResponseModel] = useState(data);
  const [responseLoading, setResponseLoading] = useState(false);
  const [keyValue, setKeyValue] = useState(1);
  const [tabColors, setTabColors] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });

  const onFormSubmit = (values) => {
    submitWithdrawalRequest(withdrawalRequestId)
      .then((response) => {
        setResponseLoading(true);
        if (response) {
          fromPage == 4
            ? dispatch2(
                globalToastInfo({
                  showToast: true,
                  toastMessage: "Request submitted successfully",
                })
              )
            : dispatch(
                setManageDistributionToastInfo({
                  showToast: true,
                  toastMessage: "Data saved successfully",
                })
              );
          history.push(
            getAdvancedPathWithParam({
              path:
                fromPage == 4
                  ? MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL
                  : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
              pathParam: fromPage == 4 ? [] : censusId,
            })
          );
        }

        // if (response) {
        //   dispatch(
        //     setManageDistributionToastInfo({
        //       showToast: true,
        //       toastMessage: "Request submitted successfully",
        //     })
        //   );
        //   history.push(
        //     getAdvancedPathWithParam({
        //       path:
        //         fromPage == 4
        //           ? MANAGE_TRANSACTION_ROUTES.DRAFT
        //           : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        //       pathParam: fromPage != 4 && censusId,
        //     })
        //   );
        // }
      })
      .catch((ex) => setResponseLoading(false));
  };

  const tabChange = (key) => {
    setKeyValue(key);
  };

  const setTabColor = (tabValue) => {
    return keyValue == tabValue
      ? "#2f80ed"
      : false
      ? tabColors[tabValue]
        ? "red"
        : "green"
      : "#bdbdbd";
  };

  const setTabIcon = (tabValue) => {
    return tabColors[tabValue] == true ? faExclamationCircle : faCheckCircle;
  };

  const setTabClass = (tabValue) => {
    return keyValue == tabValue
      ? "active"
      : false
      ? tabColors[tabValue]
        ? "error"
        : "green"
      : "";
  };

  const buttons = [
    {
      request: 2,
      label: "Edit",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path: ROUTES.WITHDRAWAL_REQUEST,
        pathParam: withdrawalRequestId,
        //responseModel?.approveWithdrawalRequests?.withdrawalRequestId,
      }),
    },
    {
      request: 3,
      label: "",
      variant: "link",
      type: "button",
      icon: faTimes,
      link: getPathWithParam({
        path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        pathParam: censusId,
      }),
    },
    {
      request: 2,
      label: "Reject",
      variant: "outline-danger",
      type: "button",
      onclick: () => ApproveRejectApi(false),
    },
    {
      request: 2,
      label: "Approve",
      variant: "primary",
      type: "button",
      onclick: () => ApproveRejectApi(true),
    },
    {
      request: 1,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path:
          fromPage == 4
            ? MANAGE_TRANSACTION_ROUTES.DRAFT
            : MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
        pathParam: fromPage != 4 && censusId,
      }),
    },
    {
      request: 1,
      label: "Submit",
      variant: "primary",
      type: "submit",
    },
  ];

  const ApproveRejectApi = (aproveOrReject) => {
    approvalWithdrawalRequest({
      userId: 1,
      withdrawalrequestId: withdrawalRequestId,
      //responseModel?.approveWithdrawalRequests.withdrawalRequestId,
      userRole: 1,
      approval: aproveOrReject,
    })
      .then((res) => {})
      .catch((error) => {});
  };

  useDeepEffect(
    () => {
      dispatch(
        setWithdrawalRequestPageData({
          formName: "censusId",
          fieldData: censusId,
        })
      );
    },
    [censusId],
    false
  );

  const [filteredValues, setFilteredValues] = useState({});
  const [censusInformationLoading, setCensusInformationLoading] = useState(
    false
  );

  useDeepEffect(() => {
    if (censusId) {
      setCensusInformationLoading(true);
      getEmployeeCensusInformation(parseInt(censusId)).then((response) => {
        setCensusInformationLoading(false);
        setFilteredValues(response);
      });
    }
  }, [censusId]);
  return (
    <LoaderWrapper
      isLoading={responseLoading || censusInformationLoading}
      loaderText=""
    >
      <Formik
        initialValues={{
          ...initialValues,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          ...rest
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <ManageDistributionLayoutNew
                withdrawalRequestId={withdrawalRequestId}
                buttons={
                  fromPage == 3
                    ? buttons.filter((x) => x.request == 3)
                    : responseModel?.withdrawalStatus == 1
                    ? buttons.filter((x) => x.request == 1)
                    : responseModel?.withdrawalStatus == 2
                    ? buttons.filter((x) => x.request == 2)
                    : null
                }
                layoutHeader="Transaction"
                //filteredValues={filteredValues}
                isWithdrawalSummary={true}
                // employeeImage={employeeImage}
              >
                <div className="d-flex">
                  <div
                    className="manage-company-column manage-menu-items"
                    style={{ width: "40%" }}
                  >
                    <div
                      className="summaryCard_Heading"
                      style={{ fontSize: "16px" }}
                    >
                      Employee Details
                    </div>
                    <div
                      className="summaryCard_HeaderLine"
                      style={{ width: "290px" }}
                    ></div>
                    <div
                      className="d-flex flex-column transaction-employee-details"
                      style={{ textAlign: "center" }}
                    >
                      <div className="d-flex justify-content-center">
                        {!isEmpty(employeeImage) ? (
                          <div>
                            <img
                              alt=""
                              src={employeeImage}
                              style={{
                                width: "78px",
                                height: "78px",
                                borderRadius: "50%",
                              }}
                              className="img-fluid"
                            />
                          </div>
                        ) : (
                          <div>
                            <div style={{ marginTop: "50%" }}>
                              <GetInitials name={filteredValues.firstName} />
                            </div>
                          </div>

                          // <div>
                          //   <div style={{ marginLeft: "35%" }}>
                          //     <GetInitials name={filteredValues.firstName} />
                          //   </div>
                          //   <div style={{ marginLeft: "55%" }}>
                          //     <Link onClick={() => setisPopupOpen(true)}>
                          //       {/* <GetInitials name={companyName} /> */}
                          //       <FontAwesomeIcon icon={faPencilAlt} size="1x" />
                          //     </Link>
                          //   </div>
                          // </div>
                        )}
                      </div>
                      <div className="trans-employee-name mt-2">
                        {filteredValues.firstName} {filteredValues.middleName}{" "}
                        {filteredValues.lastName}
                      </div>
                      <div className="employee-id mt-1">
                        {ssnMasking(
                          filteredValues.uniquePersonalIdentification
                        )}
                      </div>
                      {filteredValues.employmentStatus == "Active" ? (
                        <div className="employee-status mt-1">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            color=" #1C7E18"
                            size="md"
                          />{" "}
                          {filteredValues.employmentStatus}
                        </div>
                      ) : filteredValues.employmentStatus == "Terminated" ? (
                        <div className="employee-status-danger mt-1">
                          <FontAwesomeIcon
                            icon={faTimesCircle}
                            color="#DE2323"
                            size="md"
                          />{" "}
                          {filteredValues.employmentStatus}
                        </div>
                      ) : (
                        filteredValues.employmentStatus
                      )}
                      <div className="company-name mt-1">
                        {filteredValues.companyName}
                      </div>
                      <div
                        className="more-info mt-1"
                        onClick={() => setMoreInfoSlideOpen(true)}
                      >
                        more info
                      </div>

                      <SliderPanel
                        isOpen={moreInfoSlideOpen}
                        size="80"
                        showCancel={false}
                        backdropClicked={() => setMoreInfoSlideOpen(false)}
                      >
                        {" "}
                        <div>
                          <div className="disp-flex-row justify-content-space-between dark-grey-color fw-500 ft-16 Border-Bottom census-tabs-head">
                            <p className="plan-sub-heading">
                              Employee Information
                            </p>
                            <FontAwesomeIcon
                              icon={faTimes}
                              style={{ cursor: "pointer" }}
                              onClick={() => setMoreInfoSlideOpen(false)}
                            />
                          </div>
                          <Tabs
                            style={{ border: "none", marginTop: "20px" }}
                            activeKey={keyValue}
                            transition={false}
                            onSelect={tabChange}
                            mountOnEnter
                            unmountOnExit
                          >
                            <Tab
                              eventKey={1}
                              style={{ textAlign: "initial" }}
                              title={
                                <div>
                                  <FontAwesomeIcon
                                    icon={setTabIcon(1)}
                                    color={setTabColor(1)}
                                  />
                                  &nbsp;
                                  <span class="tabName">
                                    Personal{" "}
                                    <span className="pl-20">Details</span>
                                  </span>
                                </div>
                              }
                              tabClassName={setTabClass(1)}
                            >
                              <WithdrawalRequestPersonalInformationFields
                                fields={fields}
                                filteredValues={filteredValues}
                              />
                            </Tab>

                            <Tab
                              style={{ border: "none", textAlign: "initial" }}
                              eventKey={2}
                              title={
                                <div>
                                  <FontAwesomeIcon
                                    icon={setTabIcon(2)}
                                    color={setTabColor(2)}
                                  />
                                  &nbsp;
                                  <span class="tabName">
                                    Contact Information &{" "}
                                    <span className="pl-20">
                                      Bank Account Details
                                    </span>
                                  </span>
                                </div>
                              }
                              tabClassName={setTabClass(2)}
                              disabled={false}
                            >
                              <WithdrawalRequestContactInformationFields
                                fields={fields}
                                filteredValues={filteredValues}
                              />
                            </Tab>

                            <Tab
                              style={{ textAlign: "initial" }}
                              eventKey={3}
                              title={
                                <div>
                                  <FontAwesomeIcon
                                    icon={setTabIcon(3)}
                                    color={setTabColor(3)}
                                  />
                                  &nbsp;
                                  <span class="tabName">
                                    Employment & Age Details
                                    {/* <span className="pl-20"></span> */}
                                  </span>
                                </div>
                              }
                              tabClassName={setTabClass(3)}
                              disabled={false}
                            >
                              <WithdrawalRequestEmploymentAgeDetail
                                fields={fields}
                                filteredValues={filteredValues}
                              />
                            </Tab>

                            <Tab
                              style={{ textAlign: "initial" }}
                              eventKey={4}
                              title={
                                <div>
                                  <FontAwesomeIcon
                                    icon={setTabIcon(4)}
                                    color={setTabColor(4)}
                                  />
                                  &nbsp;
                                  <span class="tabName">
                                    Employee{" "}
                                    <span className="pl-20">
                                      Classification
                                    </span>
                                  </span>
                                </div>
                              }
                              tabClassName={setTabClass(4)}
                              disabled={false}
                            >
                              <WithdrawalRequestEmployeeClassification
                                fields={fields}
                                filteredValues={filteredValues}
                              />
                            </Tab>

                            <Tab
                              style={{ textAlign: "initial" }}
                              eventKey={5}
                              title={
                                <div>
                                  <FontAwesomeIcon
                                    icon={setTabIcon(5)}
                                    color={setTabColor(5)}
                                  />
                                  &nbsp;
                                  <span class="tabName">
                                    Other{" "}
                                    <span className="pl-20">Information</span>
                                  </span>
                                </div>
                              }
                              tabClassName={setTabClass(5)}
                              disabled={false}
                            >
                              <WithdrawalRequestOtherInformation
                                fields={fields}
                                filteredValues={filteredValues}
                              />
                            </Tab>
                          </Tabs>
                        </div>
                      </SliderPanel>
                    </div>
                  </div>
                  <div style={{ width: "85%" }}>
                    <WithdrawalSummaryComponent
                      responseModel={responseModel}
                      state={state}
                      setResponseModel={setResponseModel}
                      setResponseLoading={setResponseLoading}
                      filteredValues={filteredValues}
                      setSliderOpen1={setSliderOpen1}
                    />
                  </div>
                </div>
                <SliderPanel
                  isOpen={sliderOpen1}
                  size="35"
                  showCancel={false}
                  backdropClicked={() => setSliderOpen1(false)}
                >
                  <div className="disp-flex-col">
                    <div
                      className="disp-flex-row"
                      style={{
                        justifyContent: "space-between",
                        fontWeight: "500",
                        fontSize: "16px",
                        borderBottom: "1px solid #BDBDBD",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          marginBottom: "20px",
                        }}
                      >
                        Terms & Conditions
                      </p>
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => setSliderOpen1(false)}
                      />
                    </div>
                    <ul style={{ marginTop: "15px" }}>
                      <li>
                        I have read and understood all the rules governing
                        distributions/ rollover requests from my 401k plan.
                      </li>
                      <li>
                        I understand that funds may impose redemption fees on
                        certain transfers, redemptions or exchanges if assets
                        are held less than the period stated in the funds
                        prospectus or other disclosure documents.
                      </li>
                      <li>
                        I understand that it is entirely my responsibility to
                        ensure that this election conforms with all applicable
                        provisions of the Internal Revenue Code and that the
                        Plan into which I am rolling money over will accept the
                        dollars, if applicable.
                      </li>
                      <li>
                        I understand that I am liable for any income tax and/or
                        penalties assessed by the IRS for any election I have
                        chosen.
                      </li>
                      <li>
                        I understand that once my payment has been processed, it
                        cannot be changed.
                      </li>
                    </ul>
                  </div>
                </SliderPanel>
              </ManageDistributionLayoutNew>
            </Form>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};
export default WithdrawalSummaryContainer;
